import { render, staticRenderFns } from "./ServicerGroupHelpList.vue?vue&type=template&id=e022c8ee&"
import script from "./ServicerGroupHelpList.vue?vue&type=script&lang=js&"
export * from "./ServicerGroupHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports